<div class="container iep-form-container">
  <div class="row">
    <div class="col-lg-12" style="padding-left: 0px; padding-right: 0px">
      <div class="panel panel-primary">
        <div class="panel-heading">
          <h4 style="margin-bottom: 3px; margin-top: 5px">
            Manage Solar Scheduler
          </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <form
                [formGroup]="exportDataForm"
                #formDirective="ngForm"
                novalidate
              >
                <div class="row" *ngIf="displayAllSiteID">
                  <div class="col-lg-1"></div>
                  <div class="col-lg-3 col-sm-3">
                    <mat-label class="label-input">Select Site:</mat-label>
                  </div>
                  <div class="col-lg-7 col-sm-7">
                    <mat-form-field>
                      <mat-select
                        formControlName="siteCtr"
                        name="siteID"
                        ngDefaultControl
                        [(ngModel)]="siteId"
                        placeholder="-- Select SiteID --"
                        required
                      >
                        <mat-option value="">-- Select SiteID --</mat-option>
                        <mat-option
                          *ngFor="let item of sites"
                          value="{{ item.siteId }}"
                          >{{ item.siteId }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          exportDataForm.get('siteCtr').hasError('required')
                        "
                        class="help-block"
                        >This field is required.</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>

                <div
                  class="row"
                  style="margin-top: 1px; margin-bottom: 5px"
                  *ngIf="!displayAllSiteID"
                >
                  <div class="col-lg-1"></div>
                  <div class="col-lg-3 col-sm-3">
                    <mat-label style="margin-bottom: 3px">Site ID :</mat-label>
                  </div>
                  <div class="col-lg-7 col-sm-7">
                    {{ siteId }}
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-1"></div>
                  <div class="col-lg-3 col-sm-3">
                    <mat-label class="label-input">Select Date</mat-label>
                  </div>
                  <div class="col-lg-3 col-sm-3">
                    <mat-form-field>
                      <input
                        matInput
                        placeholder="Select Date"
                        name="selDate"
                        [matDatepicker]="picker"
                        required
                        [formControl]="date"
                        [max]="max"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker
                        #picker
                        [startView]="startView"
                        disabled="false"
                      >
                      </mat-datepicker>

                      <mat-error *ngIf="date.invalid">Invalid Date</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4">
                    <button
                      bciprimarybutton
                      class="button-primary"
                      id="regenrateBtn"
                      style="margin-left: 3px"
                      [disabled]="exportDataForm.invalid || date.invalid"
                      (click)="addMissingSolarValues()"
                    >
                      <span>
                        <mat-icon
                          aria-hidden="false"
                          aria-label="weather icon"
                          class="bosch-ic-checkmark-frame"
                          style="width: max-content"
                        ></mat-icon> </span
                      >Add missing values
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
